import React from 'react';
import { PriceAlert } from '../components/PriceAlert';
import { Hero } from '../components/Hero';
import { Testimonial } from '../components/Testimonial';
import { ProblemSolution } from '../components/ProblemSolution';
import { ValueStack } from '../components/ValueStack';
import { ModuleBreakdown } from '../components/ModuleBreakdown';
import { Guarantee } from '../components/Guarantee';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function LandingPage() {
  return <div className="w-full min-h-screen bg-navy font-body text-white" data-id="element-1111">
      <PriceAlert data-id="element-1112" />
      <Hero data-id="element-1113" />
      <Testimonial data-id="element-1114" />
      <ProblemSolution data-id="element-1115" />
      <ValueStack data-id="element-1116" />
      <ModuleBreakdown data-id="element-1117" />
      <Guarantee data-id="element-1118" />
      <PricingSection data-id="element-1119" />
      <Footer data-id="element-1120" />
      <RecentPurchaseToast data-id="element-1121" />
    </div>;
}